// extracted by mini-css-extract-plugin
module.exports = {"mobile":"360","tablet":"768","desktop":"1280","sliderArrow":"_16lpJ","right":"_2bMrB","left":"_1GIa8"};